<div class="playback-settings">

  @if (playbackStatus === PlaybackStatus.LOADING) {
    <mat-spinner [diameter]="52"></mat-spinner>
  }
  @if (playbackStatus === PlaybackStatus.STOPPED) {
    <button mat-button
            class="playback-button"
            (click)="actionTriggered(PlaybackAction.PLAY)"
    >
      <mat-icon class="filled-icon">play_arrow</mat-icon>
    </button>
  } @else if (playbackStatus === PlaybackStatus.PLAYING) {
    <button mat-button
            class="playback-button"
            (click)="actionTriggered(PlaybackAction.STOP)"
    >
      <mat-icon class="filled-icon">pause</mat-icon>
    </button>
  }

  <div>
    <button
      mat-button
      class="speed-button"
      [matMenuTriggerFor]="menu"
      [disabled]="playbackStatus === PlaybackStatus.PLAYING"
    >
      <span>{{ speed }}x</span>
    </button>

    <mat-menu #menu="matMenu" class="speed__menu">
      @for (speed of speeds; track speed) {
        <button mat-menu-item (click)="onSpeedChanged(speed)">{{ speed }}x</button>
      }
    </mat-menu>
  </div>

</div>
<div class="timeline-wrapper">
  @if (showAssignmentsBar()) {
    <div class="timeline-row">
      <div class="timeline-label">
        Assignment
      </div>
      <div class="timeline-bar-wrapper">
        @for (assignment of assignmentItems; track assignment) {
          <div class="timeline-assignment"
               [ngStyle]="{ 'left.%': assignment.left, 'width.%': assignment.width }"
          >
            <span [matTooltip]="assignment.name">{{ assignment.name }}</span>
          </div>
        }
      </div>
    </div>
  }
  @if (showSpreaderBar()) {
    <div class="timeline-row">
      <div class="timeline-label">
        Spreading
      </div>
      <div class="timeline-bar-wrapper">
        @for (spreaderItem of spreaderItems; track spreaderItem) {
          <div class="timeline-spreading"
               [ngStyle]="{ 'left.%': spreaderItem.left, 'width.%': spreaderItem.width }"
          >
          </div>
        }
      </div>
    </div>
  }
  @if (showPlowBar()) {
    <div class="timeline-row">
      <div class="timeline-label">
        Blade Down
      </div>
      <div class="timeline-bar-wrapper">
        @for (plowItem of plowItems; track plowItem) {
          <div class="timeline-plowdown"
               [ngStyle]="{ 'left.%': plowItem.left, 'width.%': plowItem.width }"
          >
          </div>
        }
      </div>
    </div>
  }
  @if (showSweepingBar()) {
    <div class="timeline-row">
      <div class="timeline-label">
        Sweeping
      </div>
      <div class="timeline-bar-wrapper">
        @for (sweepingItem of sweepingItems; track sweepingItem) {
          <div class="timeline-plowdown"
               [ngStyle]="{ 'left.%': sweepingItem.left, 'width.%': sweepingItem.width }"
          >
          </div>
        }
      </div>
    </div>
  }
  @if (showMowingBar()) {
    <div class="timeline-row">
      <div class="timeline-label">
        Mowing
      </div>
      <div class="timeline-bar-wrapper">
        @for (mowingItem of mowingItems; track mowingItem) {
          <div class="timeline-plowdown"
               [ngStyle]="{ 'left.%': mowingItem.left, 'width.%': mowingItem.width }"
          >
          </div>
        }
      </div>
    </div>
  }
  <div class="timeline-row">
    <div class="timeline-label">
      Duration
    </div>
    <div class="timeline-bar-wrapper">
      <div class="timeline-duration">
        <div class="timeline-marker"
             [ngStyle]="{ 'left.px': this.markerPositionPx, 'height.px': getTimeLineMarkerHeight() }"
             (mousedown)="onMarkerMouseDown($event)"
             [class.dragging]="isDragging"
        >
          <span class="timeline-marker-label"
                [ngStyle]="{'right.px': this.markerFromEndPx < 20 ? -this.markerFromEndPx + 5 : undefined,
                            'left': this.markerFromEndPx < 20 ? 'unset': undefined}"
          >{{ currentTimestamp | date:'hh:mm:ss' }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="timeline-row">
    <div class="timeline-label">

    </div>
    <div class="timeline-bar-wrapper">
      <div class="timeline-axis">
        <div class="timeline-axis-label-bar" (click)="onTimeLineClick($event)" #timeLineBar>
          @for (marker of timeAxisMarkers; track $index) {
            <div
              class="axis-marker-wrapper"
              [style.left.%]="marker.position"
            >
              <div
                class="axis-marker"
                [style.transform]="marker.isEnd ? 'translateX(-1px)': 'translateX(0)'"
              ></div>

              <div
                class="axis-label"
                [style.transform]="marker.isEnd ? 'translateX(-100%)': 'translateX(-50%)'"
              >
                {{ marker.label }}
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
